import { IconProps } from "./types";

export default function IcoPet({
	color = "#6B7280",
	width = "17",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 17 16"
			fill="none"
		>
			<g clipPath="url(#clip0_650_2231)">
				<path
					d="M8.06261 2.90315C8.50948 4.24377 8.05323 5.5969 7.04386 5.92815C6.03448 6.2594 4.85323 5.44065 4.40636 4.10002C3.95948 2.7594 4.41573 1.40627 5.42511 1.07502C6.43448 0.743772 7.61573 1.56252 8.06261 2.90315ZM4.12198 6.20627C4.71261 7.21877 4.56886 8.3969 3.80323 8.8344C3.03761 9.2719 1.93761 8.80627 1.35011 7.79377C0.762607 6.78127 0.900107 5.60315 1.66573 5.16565C2.43136 4.72815 3.53136 5.19377 4.11886 6.20627H4.12198ZM3.14698 12.5375C4.78448 8.1219 7.69386 7.00002 8.98448 7.00002C10.2751 7.00002 13.1845 8.1219 14.822 12.5375C14.9345 12.8406 14.9845 13.1656 14.9845 13.4906V13.5406C14.9845 14.3469 14.3314 15 13.5251 15C13.1657 15 12.8095 14.9563 12.4626 14.8688L9.71261 14.1813C9.23448 14.0625 8.73448 14.0625 8.25636 14.1813L5.50636 14.8688C5.15948 14.9563 4.80323 15 4.44386 15C3.63761 15 2.98448 14.3469 2.98448 13.5406V13.4906C2.98448 13.1656 3.03448 12.8406 3.14698 12.5375ZM14.1657 8.8344C13.4001 8.3969 13.2564 7.21877 13.847 6.20627C14.4376 5.19377 15.5345 4.72815 16.3001 5.16565C17.0657 5.60315 17.2095 6.78127 16.6189 7.79377C16.0282 8.80627 14.9314 9.2719 14.1657 8.8344ZM10.6751 5.92815C9.66573 5.5969 9.20948 4.24377 9.65636 2.90315C10.1032 1.56252 11.2845 0.743772 12.2939 1.07502C13.3032 1.40627 13.7595 2.7594 13.3126 4.10002C12.8657 5.44065 11.6845 6.2594 10.6751 5.92815Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_650_2231">
					<path d="M0.984375 0H16.9844V16H0.984375V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
